import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttachmentDetails, AttachmentOperation } from 'src/app/interfaces/dashboard';
import { FileNameTransformPipe } from 'src/app/pipes/filename-transform.pipe';
import { AttachmentService } from 'src/app/services/attachment.service';
import { commonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-file-upload-popup',
  templateUrl: './file-upload-popup.component.html',
  styleUrl: './file-upload-popup.component.scss'
})
export class FileUploadPopupComponent {
  filePipe = new FileNameTransformPipe();
  @Input() buttonLabel: string = 'Browse';
  @Input() multipleAllowed: boolean = false;
  @Input() acceptedFileTypes: string[] = this.commonService.commonAcceptedFiles;
  @Input() labelCSS = 'browseBtn';
  @Input() elementId = '';
  @Input() mainButtonCSS = 'custom-btn';
  @Input() isDisabled: boolean = false;
  @Input() displayBtn: boolean = false;
  @Output() fileUploaded = new EventEmitter<AttachmentDetails>();
  fileAttachmentDetails = new Array<AttachmentDetails>();
  constructor(private commonService: commonService,private attachmentservice: AttachmentService) {

  }
  addFiles(event: any) {
    let files = event.target.files;
    let invalidFiles_Type: any[] = [];
    let invalidFiles_Size: any[] = [];
    if (files.length > 0) {
      let fileList = [...files];
      let validFiles = fileList.filter((x: File) => this.commonService.isValidFileSize(x?.size) && this.commonService.isValidFile(x, this.acceptedFileTypes));
      invalidFiles_Size = fileList.filter((x: File) => !this.commonService.isValidFileSize(x?.size));
      invalidFiles_Type = fileList.filter((x: File) => !this.commonService.isValidFile(x, this.acceptedFileTypes));
      if (validFiles.length > 0) {
        let form = new FormData();
        validFiles.forEach((file: any) => form.append("files", file));
        this.attachmentservice.saveAttachment(form).subscribe({
          next: (response: any) => {
            let fileAttachmentList: AttachmentDetails[] = [];
            if (response) {
              response.forEach((res: any) => {
                //let file = validFiles.find(file => file.name == this.filePipe.transform(res));
                let file = validFiles.find(file => file.name == res.fileName);
                if (file) {
                  let data = new AttachmentDetails();
                  data.id = 0;
                  data.fileName = res.fileName;
                  data.operation = AttachmentOperation.Create;
                  data.fileType = file.type;
                  data.fileSize = file.size;
                  data.blobURI = res.blobFileName;
                  fileAttachmentList.push(data);
                }
              });
            }

            // Sending Attachmentent DTO to parent component
            if (fileAttachmentList.length) {
              fileAttachmentList.forEach((attachment: AttachmentDetails) => {
                this.fileUploaded.emit(attachment);
              });
            }
          },
          error: () => {
            this.commonService.showNotificationMessage('File already exists', 'error', 'center');
          }
        });

        event.target.value = null;
      }
    } else {
      event.target.value = null;
    }


    if (invalidFiles_Size.length > 0) {
      const errorMessage: string = `${this.commonService.fileSizeError}`;
      this.commonService.showNotificationMessage(errorMessage, 'error', 'center');
    }

    if (invalidFiles_Type.length > 0) {
      const errorMessage: string = `Please select a valid file (${this.acceptedFileTypes.join(', ')})`;
      this.commonService.showNotificationMessage(errorMessage, 'error', 'center');
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault(); // Prevent default behavior
  }

  onDropSuccess(event: any): void {
    event.preventDefault(); // Prevent default behavior
    let files = event.dataTransfer?.files;

    let data = {
      target: {
        files: files
      }
    };

    this.addFiles(data);
  }
}
